import { render, staticRenderFns } from "./MarcaList.vue?vue&type=template&id=2d51d36e&scoped=true"
import script from "./MarcaList.vue?vue&type=script&lang=js"
export * from "./MarcaList.vue?vue&type=script&lang=js"
import style0 from "./MarcaList.vue?vue&type=style&index=0&id=2d51d36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51d36e",
  null
  
)

export default component.exports